import styled from "styled-components";

const Game = styled.p`
  font-weight: 200;
  font-size: 1.6rem;
  margin: 0;
`

export default Game;
